import styled, { createGlobalStyle, keyframes } from 'styled-components';

const ALTURA_BARRA_AVISO = 48;

const ROXO_ESCURO = '#3d0a73';
const ROXO = '#57069e';
const ROXO_CLARO = '#6f2bd1';
const AMBAR = '#ffb020';
const DEGRADE_MARCA = `linear-gradient(135deg, ${ROXO_ESCURO} 0%, ${ROXO} 55%, ${ROXO_CLARO} 100%)`;

const descer = keyframes`
  from {
    transform: translateY(-100%);
  }

  to {
    transform: translateY(0);
  }
`;

const surgir = keyframes`
  from {
    opacity: 0;
    transform: translateY(16px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

/* ---------- Barra de aviso ---------- */

export const EstiloGlobalBarraAviso = createGlobalStyle`
  :root {
    --altura-aviso-encerramento: ${ALTURA_BARRA_AVISO}px;
  }

  body {
    padding-top: var(--altura-aviso-encerramento);
  }
`;

export const ContainerBarra = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1002;
  height: ${ALTURA_BARRA_AVISO}px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 0 16px;
  background: ${DEGRADE_MARCA};
  color: #fff;
  font-size: 14px;
  box-shadow: 0 2px 10px rgba(36, 6, 70, 0.35);
  animation: ${descer} 0.4s ease-out;
`;

export const IconeBarra = styled.span`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.16);

  @media (max-width: 520px) {
    display: none;
  }
`;

export const TextoBarra = styled.p`
  margin: 0;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: 0.1px;

  strong {
    font-weight: 600;
  }

  .texto-curto {
    display: none;
  }

  @media (max-width: 1200px) {
    .texto-completo {
      display: none;
    }

    .texto-curto {
      display: inline;
    }
  }

  @media (max-width: 560px) {
    .prefixo-curto {
      display: none;
    }
  }
`;

export const SeloContagem = styled.span<{ urgente: boolean }>`
  flex-shrink: 0;
  padding: 3px 12px;
  border-radius: 999px;
  font-size: 12.5px;
  font-weight: 600;
  white-space: nowrap;
  background: ${({ urgente }) =>
    urgente ? AMBAR : 'rgba(255, 255, 255, 0.16)'};
  color: ${({ urgente }) => (urgente ? '#3d2600' : '#fff')};
  border: 1px solid
    ${({ urgente }) => (urgente ? '#ffc65c' : 'rgba(255, 255, 255, 0.3)')};

  @media (max-width: 800px) {
    display: none;
  }
`;

export const BotaoBarra = styled.button`
  flex-shrink: 0;
  border: none;
  border-radius: 999px;
  padding: 6px 16px;
  background: #fff;
  color: ${ROXO};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  }

  &:focus-visible {
    outline: 2px solid ${AMBAR};
    outline-offset: 2px;
  }
`;

/* ---------- Modal do comunicado ---------- */

export const EstiloGlobalModal = createGlobalStyle`
  /* acima dos modais do Bootstrap (1050) e abaixo do SweetAlert (1060) */
  .modal.modal-comunicado-encerramento {
    z-index: 1058;
  }

  .modal-backdrop.modal-comunicado-encerramento-fundo {
    z-index: 1057;
  }

  .modal-dialog.modal-comunicado-encerramento-dialogo {
    max-width: 560px;
  }

  .modal-content.modal-comunicado-encerramento-conteudo {
    border: none;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 24px 60px rgba(36, 6, 70, 0.35);
  }
`;

export const CabecalhoModal = styled.div`
  position: relative;
  padding: 28px 28px 22px;
  text-align: center;
  color: #fff;
  background: ${DEGRADE_MARCA};

  h2 {
    margin: 12px 0 0;
    font-size: 22px;
    font-weight: 600;
    color: #fff;
  }

  span {
    display: block;
    margin-top: 4px;
    font-size: 14px;
    opacity: 0.85;
  }
`;

export const IconeCabecalho = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.3);
`;

export const BotaoFecharModal = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.18);
  }

  &:focus-visible {
    outline: 2px solid ${AMBAR};
  }
`;

export const CorpoModal = styled.div`
  padding: 24px 28px 8px;
  color: #313638;
  font-size: 15px;
  line-height: 1.6;

  p {
    margin: 0 0 12px;
  }

  strong {
    color: #212336;
    font-weight: 600;
  }
`;

export const DestaquePrazo = styled.div<{ urgente: boolean }>`
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 16px 0 4px;
  padding: 14px 16px;
  border-radius: 12px;
  border-left: 4px solid ${({ urgente }) => (urgente ? AMBAR : ROXO)};
  background: ${({ urgente }) => (urgente ? '#fff6e5' : '#f4ecff')};

  svg {
    flex-shrink: 0;
    color: ${({ urgente }) => (urgente ? '#b26b00' : ROXO)};
  }

  div {
    display: flex;
    flex-direction: column;
    line-height: 1.35;
  }

  strong {
    font-size: 17px;
  }

  span {
    font-size: 13.5px;
    color: #5a5e6b;
  }
`;

export const RodapeModal = styled.div`
  display: flex;
  justify-content: center;
  padding: 12px 28px 26px;
`;

export const BotaoPrimario = styled.button`
  min-width: 180px;
  border: none;
  border-radius: 999px;
  padding: 10px 32px;
  background: ${ROXO};
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, transform 0.15s ease;

  &:hover {
    background: #46057e;
    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 2px solid ${ROXO_CLARO};
    outline-offset: 2px;
  }
`;

/* ---------- Cartão de contato ---------- */

export const ContainerContato = styled.div`
  margin-top: 16px;
  padding: 16px;
  border-radius: 12px;
  background: #f8f7fb;
  border: 1px solid #ece6f5;
  text-align: left;

  .rotulo {
    display: block;
    margin-bottom: 8px;
    font-size: 13px;
    color: #6b6f80;
  }

  .dados {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .pessoa {
    display: flex;
    flex-direction: column;
    line-height: 1.4;

    strong {
      font-size: 16px;
      color: #212336;
    }

    span {
      font-size: 14px;
      color: #4a4e5c;
    }
  }

  .telefone {
    display: flex;
    align-items: center;
    gap: 6px;
  }
`;

export const BotaoWhatsapp = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 18px;
  border-radius: 999px;
  background: #25d366;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: background-color 0.15s ease, transform 0.15s ease;

  &:hover {
    background: #1ebe5b;
    color: #fff;
    text-decoration: none;
    transform: translateY(-1px);
  }
`;

/* ---------- Tela de acesso encerrado ---------- */

export const ContainerTelaEncerrada = styled.main`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  background: radial-gradient(
      circle at 15% 20%,
      rgba(111, 43, 209, 0.9) 0%,
      transparent 45%
    ),
    linear-gradient(135deg, #2b0652 0%, ${ROXO} 60%, ${ROXO_CLARO} 100%);
`;

export const CartaoEncerrado = styled.section`
  width: 100%;
  max-width: 560px;
  padding: 36px 32px 28px;
  border-radius: 20px;
  background: #fff;
  text-align: center;
  box-shadow: 0 30px 80px rgba(20, 2, 40, 0.45);
  animation: ${surgir} 0.5s ease-out;

  .logo {
    height: 56px;
    margin-bottom: 20px;
  }

  h1 {
    margin: 16px 0 12px;
    font-size: 26px;
    font-weight: 600;
    color: #212336;
  }

  p {
    margin: 0 0 10px;
    font-size: 15px;
    line-height: 1.6;
    color: #4a4e5c;
  }

  strong {
    color: #212336;
    font-weight: 600;
  }
`;

export const IconeCadeado = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #f4ecff;
  color: ${ROXO};
`;

export const BotaoSecundario = styled.button`
  margin-top: 20px;
  padding: 8px 24px;
  border: 1px solid ${ROXO};
  border-radius: 999px;
  background: transparent;
  color: ${ROXO};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover {
    background: ${ROXO};
    color: #fff;
  }
`;
